import * as React from "react";

import "./Shell.scss";

import Navigation from "./Navigation";
import Page from "./Page";
import { IPageDefinition } from "./PageDefinitionTypes";
import PageError from "./PageError";
import ScrollToTop from "./ScrollToTop";
import TopHeader from "./TopHeader";

import { pages } from "../_Generated/Pages";

import { buildCanonicalUrl, removeCanonicalUrl, setCanonicalUrl } from "./canonical";
import { getProductName, isPublicSite } from "../configuration";
import { makeFullUrl } from "../routing";

// import { Link } from "azure-devops-ui/Link";
import { BrowserRouter, Route, RouteComponentProps, Switch } from "react-router-dom";

class Shell extends React.Component {
    public render() {
        return (
            <BrowserRouter>
                <ScrollToTop>
                    <div id="page">
                        <div className="header-title">
                            <TopHeader />
                        </div>
                        <div className="nav-sidebar">
                            <Navigation />
                        </div>
                        <div id="main-content" className="main-content" role="main">
                            <Switch>
                                {// Create a route for each page
                                pages.map(this.pageToRoute)}
                                {// Create a route for the empty/root path
                                this.createRoute(pages.filter(p => p.id === "home")[0], "home", "/")}
                                {
                                    // Create a fallback route for the "page not found" scenario
                                    <Route render={this.renderFallback} key="fallback" />
                                }
                            </Switch>
                        </div>
                        {/* <Footer /> */}
                    </div>
                </ScrollToTop>
            </BrowserRouter>
        );
    }

    private pageToRoute = (page: IPageDefinition, key: number): JSX.Element => {
        return this.createRoute(page, key);
    };

    private createRoute(page: IPageDefinition, key: number | string, routeOverride?: string): JSX.Element {
        const renderPage = () => {
            document.title = page.name + " - " + getProductName();
            if (isPublicSite()) {
                const pagePath = makeFullUrl(page.url);
                setCanonicalUrl(buildCanonicalUrl(page.url, pagePath));
            }
            return <Page page={page} key={key} routeOverride={routeOverride} />;
        };
        return <Route render={renderPage} exact={true} key={key} path={routeOverride || makeFullUrl(page.url)} />;
    }

    private renderFallback = (props: RouteComponentProps): JSX.Element => {
        if (isPublicSite()) {
            removeCanonicalUrl();
        }
        return <PageError title="Page not found" details={`Invalid path: ${props.location.pathname}`} />;
    };
}

export default Shell;
